module.exports = __webpack_public_path__ + "static/media/intel.9c485e03.png";